import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import LocalizedFormat from 'dayjs/plugin/localizedFormat';

import whyDidYouRender from '@welldone-software/why-did-you-render';

import App from '@app';

// import 'moment/locale/vi';
// eslint-disable-next-line
// import 'react-day-picker/lib/style.css';
import './index.css';
import '@assets/styles/styles.less';
import dayjs from 'dayjs';

dayjs.extend(LocalizedFormat);

if (process.env.NODE_ENV === 'development') {
  whyDidYouRender(React, {
    // trackAllPureComponents: true,
  });
}

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(<App />);

// ReactDOM.render(<App />, document.getElementById('root'));
